import styled from 'styled-components';
import {colors} from '../../styles';

const ProgressBar = styled.div`
    background-color: ${props => props.trackColor || '#fff'};
    position: relative;
    width: 100%;
    height: ${({height}) => (height ? height : 5)}px;
    border-radius: ${({cornerRadius}) => (cornerRadius ? cornerRadius : 0)}px;

    ::after {
        content: '';
        position: absolute;
        background-color: ${colors.pink};
        width: 0%;
        height: 100%;
        top: 0px;
        left: 0px;
        bottom: 0px;
        transition: width
            ${({transition}) => (transition ? transition : '0.2s ease-in-out')};
        ${props => `width: ${props.percent * 100}%`};
        max-width: 100%;
        border-radius: ${({cornerRadius}) =>
            cornerRadius ? cornerRadius : 0}px;
    }
`;

export default ProgressBar;
